import React from 'react'
import {Box} from '@material-ui/core'
import qrcodeImage from '../../assets/images/qrcode.png'
import barcodeTextImage from '../../assets/images/barcode_text.png'
import barcodeNoTextImage from '../../assets/images/barcode.png'
import aplogo from '../../assets/images/logo.png'
import useStyles from './BarcodeLabelPreview.styles'
import UnitConverter from '../../utils/UnitConverter'
const borderStyles = {
  borderRadius: 10,
  border: 1,
  borderColor: '#cacaca',
}

const SCALE_MULTIPLIER = 1

function BarcodeLabelPreview({details, sheet, fields, cmpLogo}) {
  const classes = useStyles()
  function fieldName(fieldId) {
    let name = null
    if (fields) {
      Object.keys(fields).forEach(value => {
        let currentField = fields[value].find(obj => parseInt(obj.id) === parseInt(fieldId))
        if (currentField) name = currentField.name
      })
    }
    return name ? name : fieldId
  }

  const {elements, width, height} = details
  const {unit} = sheet

  // calculate scale based on width
  const remWidth = UnitConverter.convert(unit, 'rem', width)
  const contWidth = 35 // container width
  const scale = contWidth / remWidth
  // calculate container height
  const contHeight = UnitConverter.convert(unit, 'rem', height) * scale

  const boxStyles = {
    width: `calc(${width}${unit})`,
    height: `calc(${height}${unit})`,
    position: 'relative',
    margin: '0 0',
    border: '1px solid #cacaca',
    transform: `scale(${scale})`,
    transformOrigin: 'left top',
    overflow: 'hidden',
  }

  const labelElements = Object.keys(elements).map(key => {
    const {left, top, angle = 0} = elements[key]['position']
    const {height, width} = elements[key]['size']
    const {
      font_size = 16,
      font_family = 'Arial',
      color = '000000',
      font_style = null,
      text_decoration = null,
      font_weight = null,
    } = elements[key]
    // const multiplier = unit === 'in' ? BOX_WIDTH / width : (BOX_WIDTH * 25.4) / width;
    const dimension = {
      height: `${height * SCALE_MULTIPLIER}${unit}`,
      width: `${width * SCALE_MULTIPLIER}${unit}`,
    }

    const elementStyles = {
      position: 'absolute',
      top: `${top * SCALE_MULTIPLIER}${unit}`,
      left: `${left * SCALE_MULTIPLIER}${unit}`,
      height: `${height * SCALE_MULTIPLIER}${unit}`,
      width: `${width * SCALE_MULTIPLIER}${unit}`,
      overflow: 'hidden',
      // border: '1px solid #cacaca',

      textDecoration: text_decoration,
      fontStyle: font_style,
      fontWeight: font_weight,
      textAlign: elements[key]['text_align'],

      fontSize: `${font_size}pt`,
      fontFamily: font_family,
      color: `#${color}`,
      transform: `rotate(${angle}deg)`,
      lineHeight: '1.1',
    }

    let display = ''
    if (key.includes('textbox')) {
      display = <Box>{elements[key]['text']}</Box>
    } else if (key.includes('qrcode')) {
      display = <img alt="qrcode preview" src={qrcodeImage} style={dimension} />
    } else if (key.includes('barcodenotext')) {
      display = <img alt="barcode preview" src={barcodeNoTextImage} style={dimension} />
    } else if (key.includes('barcode')) {
      display = <img alt="barcode preview" src={barcodeTextImage} style={dimension} />
    } else if (key.includes('aplogo')) {
      display = <img alt="barcode preview" src={aplogo} style={dimension} />
    } else if (key.includes('companylogo')) {
      display = <img alt="barcode preview" src={cmpLogo} style={dimension} />
    } else if (key.includes('image')) {
      display = <img alt="preview" src={elements[key]['image']} style={dimension} />
    } else if (key.includes('fieldselect')) {
      //needs to be updated to the correct field_id names
      display = <Box>{fieldName(elements[key]['field_id'])}</Box>
    }

    return (
      <div style={elementStyles} key={key}>
        {display}
      </div>
    )
  })

  return (
    <div className={classes.root} style={{height: `${contHeight}rem`}}>
      <Box bgcolor="background.paper" m={8} style={boxStyles} {...borderStyles}>
        {labelElements}
      </Box>
    </div>
  )
}

export default BarcodeLabelPreview
